import React, { Fragment } from 'react';
import EntityView from '@/se/components/entity/EntityView';
import PatientLocationWidget from './PatientLocationWidget';
import get from 'lodash/get';
import PatientEvents from '../patientJourney/PatientEvents';
import ScanChartFileGenerator from './ScanChartFileGenerator';
import HSTFileGenerator from '@/components/entities/patient/views/HSTFileGenerator';

const LocationPatientView = props => {
  const events = props?.data?.log || [];

  return (
    <Fragment>
      <EntityView {...props} />
      <PatientLocationWidget
        id={get(props, 'data.id')}
        name={get(props, 'data.name')}
        room={get(props, 'data.room')}
        discharged={!!get(props, 'data.dischargedAt')}
        events={get(props, 'data.events')}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'right' }}>
        {props?.data?.procedure?.id && props?.scope?.hospital?.modules?.showQRCode && (
          <ScanChartFileGenerator procedureId={props?.data?.procedure?.id} />
        )}
        <HSTFileGenerator procedureId={props?.data?.procedure?.id} />
      </div>
      {events.length !== 0 ? (
        <div style={{ marginTop: '20px' }}>
          <PatientEvents events={events} debug={false} patientId={props?.data?.id} />
        </div>
      ) : null}
    </Fragment>
  );
};

export default LocationPatientView;
